// Store Locator with Mapbox integration
document.addEventListener("DOMContentLoaded", () => {
  // Initialize the store locator
  // Wait for Mapbox GL JS to be loaded
  if (typeof mapboxgl === "undefined") {
    // If Mapbox GL JS is not loaded yet, wait for it
    const checkMapbox = setInterval(() => {
      if (typeof mapboxgl !== "undefined") {
        clearInterval(checkMapbox);
        initStoreLocator();
      }
    }, 100);
  } else {
    // If Mapbox GL JS is already loaded, initialize immediately
    initStoreLocator();
  }
});

// Global variables
let map;
let markers = [];
let boutiques = [];
let suggestions = [];
let mapboxAccessToken = "{{ section.settings.mapbox_access_token }}";
let defaultLat = null;
let defaultLng = null;
let defaultZoom = 8;
let mapStyle = "mapbox://styles/mapbox/streets-v11";
// If the token is not set in the section settings, use a default one for development
if (!mapboxAccessToken || mapboxAccessToken.includes("section.settings")) {
  // This is a placeholder - you should replace with your actual token
  mapboxAccessToken =
    "pk.eyJ1Ijoic3RlbGxhZm9yZXN0MjAyNSIsImEiOiJjbWZmNnk4cncwaTJ3MmtzZ2E4cHJwdG53In0.ImIIVD-r50XlSgYsBJpXQA";
}

// Declare mapboxgl and MapboxGeocoder
mapboxgl.accessToken = mapboxAccessToken;
const MapboxGeocoder = window.MapboxGeocoder;

function initStoreLocator() {
  // Initialize Mapbox
  initMapbox();

  // Fetch boutiques data
  fetchBoutiques();

  // Set up event listeners
  setupEventListeners();
}

function initMapbox() {
  // Set Mapbox access token
  mapboxgl.accessToken = mapboxAccessToken;

  // Get default map settings from section settings or use defaults
  defaultLat = Number.parseFloat(
    document.querySelector("#mapbox-container").dataset.centerLat || 48.8566
  );
  defaultLng = Number.parseFloat(
    document.querySelector("#mapbox-container").dataset.centerLng || 2.3522
  );
  defaultZoom = Number.parseFloat(
    document.querySelector("#mapbox-container").dataset.zoom || 12
  );
  mapStyle =
    document.querySelector("#mapbox-container").dataset.mapStyle ||
    "mapbox://styles/mapbox/streets-v11";

  // Initialize the map
  map = new mapboxgl.Map({
    container: "mapbox-container",
    style: mapStyle,
    center: [defaultLng, defaultLat],
    zoom: defaultZoom,
  });

  // Add navigation controls
  map.addControl(new mapboxgl.NavigationControl(), "top-right");

  // Add geolocation control
  map.addControl(
    new mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true,
      },
      trackUserLocation: true,
      showUserHeading: true,
    }),
    "top-right"
  );

  // Add geocoder (search) control
  const geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    mapboxgl: mapboxgl,
    marker: false,
    placeholder: "Rechercher une adresse",
  });

  // Wait for map to load before adding markers
  map.on("load", () => {
    // If we already have boutiques data, add markers
    if (boutiques.length > 0) {
      addMarkersToMap(boutiques);
    }
  });
}

function fetchBoutiques() {
  // boutiques = document.querySelectorAll(".store-locator__item");
  const boutiquesNodes = document.querySelectorAll(".store-locator__item");

  boutiques = Array.from(boutiquesNodes)
    .map((node) => {
      const jsonScript = node.querySelector("script.boutique-json");
      if (!jsonScript) return;

      let data = {};
      try {
        data = JSON.parse(jsonScript.textContent);
      } catch (e) {
        console.warn("Erreur JSON dans boutique:", e);
        return;
      }

      return {
        id: data.id,
        name: data.name,
        phone: data.tel,
        address: data.address,
        status: data.status,
        hours: data.horaires,
        latitude: parseFloat(data.latitude),
        longitude: parseFloat(data.longitude),
        node,
      };
    })
    .filter(Boolean); // filtre les nulls

  // renderBoutiques([]);

  // If map is already initialized, add markers
  // if (map && map.loaded()) {
  //   addMarkersToMap(boutiques);
  // }
}

function addMarkersToMap(boutiques) {
  // Clear existing markers
  markers.forEach((marker) => marker.remove());
  markers = [];

  // Create a bounds object to fit all markers
  const bounds = new mapboxgl.LngLatBounds();

  const storelocMap = document.querySelector(".store-locator__map");
  const currentPageBoutique = storelocMap ? storelocMap.dataset.store : null;
  let currentBoutique;

  // Add markers for each boutique
  boutiques.forEach((boutique) => {
    if (boutique.name === currentPageBoutique) {
      currentBoutique = boutique;
    }

    // Create custom marker element
    const el = document.createElement("div");
    el.className = "store-locator__marker";
    el.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M19 10.6274C19 6.96719 15.866 4 12 4C8.13401 4 5 6.96719 5 10.6274C5 12.3612 5.7032 13.9395 6.8543 15.1206L7.05025 15.3137L12 20L16.9497 15.3137L17.1457 15.1206C18.2968 13.9395 19 12.3612 19 10.6274ZM12 12.5C13.1046 12.5 14 11.6046 14 10.5C14 9.39543 13.1046 8.5 12 8.5C10.8954 8.5 10 9.39543 10 10.5C10 11.6046 10.8954 12.5 12 12.5Z" fill="currentColor"/>
    </svg>`;
    el.setAttribute("data-id", boutique.id);

    console.log("Boutique:", boutique);
    // Create popup
    const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(`
        <div class="store-locator__popup ft-body-2">
          <div class="flex items-center justify-between">
            <h3 class="h3">${boutique.name}</h3>
            <p>${boutique.phone}</p>
          </div>
          <div class="flex justify-between">
            <div class="text-grey">
              <p>${boutique?.address} ${
      boutique?.city != undefined ? ", " + boutique?.city : ""
    }</p>
            </div>
            
            </div>
          </div>
        </div>
      `);

    // Create and add marker
    const marker = new mapboxgl.Marker(el)
      .setLngLat([boutique.longitude, boutique.latitude])
      .setPopup(popup)
      .addTo(map);

    // Add click event to marker
    el.addEventListener("click", () => {
      // Highlight corresponding list item
      highlightBoutique(boutique.id);
    });

    // Add marker to array for later reference
    markers.push(marker);

    // Extend bounds to include this marker
    bounds.extend([boutique.longitude, boutique.latitude]);
  });

  // Center map on current boutique if we're on a boutique page
  if (
    currentBoutique &&
    currentBoutique.latitude &&
    currentBoutique.longitude
  ) {
    // Coordonnées du point cible
    const target = [currentBoutique.longitude, currentBoutique.latitude];

    // Convertir ces coordonnées en pixels dans le conteneur de la carte
    const targetPixel = map.project(target);

    // Pour que le point apparaisse plus à droite, on déplace la caméra vers la gauche
    targetPixel.x -= 55;

    // Convertir le nouveau point en pixels en coordonnées géographiques
    const newCenter = map.unproject(targetPixel);

    // Recentrer la carte avec le nouveau centre
    map.jumpTo({
      center: newCenter,
      zoom: 14,
    });

    // Ouvrir le popup de la boutique courante
    const currentMarker = markers.find(
      (m) => m.getElement().getAttribute("data-id") === currentBoutique.id
    );
    if (currentMarker) {
      currentMarker.togglePopup();
    }
  } else {
    // Si nous ne sommes pas sur une page de boutique, ajuster la vue pour montrer tous les marqueurs
    if (markers.length > 0) {
      map.fitBounds(bounds, {
        padding: 50,
        maxZoom: 15,
      });
    }
  }
}

function renderBoutiques(boutiques) {
  const listElement = document.getElementById("boutiques-list");
  if (!listElement) return;

  listElement.innerHTML = "";

  const dateNow = new Date();
  const currentDay = dateNow.toLocaleString("fr-FR", {
    weekday: "long",
  });

  boutiques.forEach((boutique) => {
    const boutiqueElement = boutique.node;
    // const boutiqueElement = document.createElement("div");
    // boutiqueElement.className = "store-locator__item ft-body-2";
    // boutiqueElement.setAttribute("data-id", boutique.id);
    // boutiqueElement.innerHTML = `
    //   <div class="store-locator__item-header">
    //     <h2 class="store-locator__item-name h3">${boutique.name}</h2>
    //     <p class="store-locator__item-phone">${boutique.tel}</p>
    //   </div>
    //   <div class="store-locator__item-details">
    //     <div class="store-locator__item-address text-grey">
    //       <p>${boutique.address}</p>
    //     </div>
    //     <div class="store-locator__hours-item">
    //       <span class="store-locator__day"></span>
    //     </div>
    //   </div>
    // `;

    // Add click event to list item
    boutiqueElement.addEventListener("click", () => {
      // Find the corresponding marker
      const marker = markers.find(
        (m) => m.getElement().getAttribute("data-id") === boutique.id
      );

      if (marker) {
        // Open the popup
        marker.togglePopup();

        // Center map on marker
        map.flyTo({
          center: [boutique.longitude, boutique.latitude],
          zoom: 15,
        });

        // Highlight this boutique
        highlightBoutique(boutique.id);
      }
    });

    listElement.appendChild(boutiqueElement);
  });

  const pageContainer = document.querySelector("#PageContainer");
  if (
    pageContainer.classList.contains("page-boutique") &&
    boutiques &&
    boutiques[0] &&
    boutiques[0].latitude &&
    boutiques[0].longitude
  ) {
    const target = [boutiques[0].longitude, boutiques[0].latitude];

    // Convertir ces coordonnées en pixels dans le conteneur de la carte
    const targetPixel = map.project(target);

    // Pour que le point apparaisse plus à droite, on déplace la caméra vers la gauche.
    // Par exemple, pour décaler de 200 pixels, on soustrait 200 à la coordonnée x.
    targetPixel.x -= 55;

    // Convertir le nouveau point en pixels en coordonnées géographiques
    const newCenter = map.unproject(targetPixel);
    map.setCenter(newCenter);
  }
}

function highlightBoutique(id) {
  // Remove highlight from all boutiques
  document.querySelectorAll(".store-locator__item").forEach((item) => {
    item.classList.remove("active");
  });

  // Add highlight to selected boutique
  const selectedItem = document.querySelector(
    `.store-locator__item[data-id="${id}"]`
  );
  if (selectedItem) {
    selectedItem.classList.add("active");

    // Scroll to the item if not in view
    selectedItem.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }
}

function setupEventListeners() {
  // Set up event listeners for search, filter, etc.
  const searchInput = document.getElementById("address-input");
  const searchClear = document.getElementById("search-clear");
  const currentLocationToggle = document.getElementById(
    "current-location-toggle"
  );
  const suggestionsContainer = document.createElement("div");
  suggestionsContainer.className = "store-locator__suggestions";
  suggestionsContainer.style.display = "none";

  // Add suggestions container after search input
  searchInput.parentNode.parentNode.appendChild(suggestionsContainer);

  if (searchInput) {
    let debounceTimer;

    searchInput.addEventListener("input", (event) => {
      // Handle search input
      const searchValue = event.target.value;
      if (searchClear) {
        searchClear.style.display = searchValue ? "block" : "none";
      }

      // Clear previous timer
      clearTimeout(debounceTimer);

      // Hide suggestions if input is empty
      if (!searchValue || searchValue.length < 3) {
        suggestionsContainer.style.display = "none";
        return;
      }

      // Debounce the search to avoid too many API calls
      debounceTimer = setTimeout(() => {
        // Get address suggestions
        getAddressSuggestions(searchValue, suggestionsContainer);
      }, 300);
    });

    // Handle enter key in search input
    searchInput.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        if (searchInput.value.length > 2) {
          searchAddress(searchInput.value);
          suggestionsContainer.style.display = "none";
        }
      }
    });

    // Close suggestions when clicking outside
    document.addEventListener("click", (event) => {
      if (
        !searchInput.contains(event.target) &&
        !suggestionsContainer.contains(event.target)
      ) {
        suggestionsContainer.style.display = "none";
      }
    });
  }

  if (searchClear) {
    searchClear.style.display = "none"; // Hide initially
    searchClear.addEventListener("click", () => {
      if (searchInput) {
        searchInput.value = "";
        searchClear.style.display = "none";
        suggestionsContainer.style.display = "none";

        // Reset map view to show all boutiques without animation
        if (map && markers.length > 0) {
          const bounds = new mapboxgl.LngLatBounds();
          markers.forEach((marker) => {
            bounds.extend(marker.getLngLat());
          });

          map.fitBounds(bounds, {
            padding: 50,
            maxZoom: 15,
            duration: 0, // No animation
          });
        }
      }
    });
  }

  if (currentLocationToggle) {
    currentLocationToggle.addEventListener("change", (event) => {
      // Handle filter toggle
      const isChecked = event.target.checked;

      // Filter boutiques based on open status
      const filteredBoutiques = isChecked
        ? boutiques.filter((b) => b.status.toLowerCase() === "ouvert")
        : boutiques;

      renderBoutiques(filteredBoutiques);

      // Update markers on map
      if (map) {
        // Hide all markers first
        markers.forEach((marker) => {
          marker.getElement().style.display = "none";
        });

        // Show only filtered markers
        filteredBoutiques.forEach((boutique) => {
          const marker = markers.find(
            (m) => m.getElement().getAttribute("data-id") === boutique.id
          );
          if (marker) {
            marker.getElement().style.display = "block";
          }
        });

        // Adjust map bounds if we have visible markers - without animation
        if (filteredBoutiques.length > 0) {
          const bounds = new mapboxgl.LngLatBounds();
          filteredBoutiques.forEach((boutique) => {
            bounds.extend([boutique.longitude, boutique.latitude]);
          });

          map.fitBounds(bounds, {
            padding: 50,
            maxZoom: 15,
            duration: 0, // No animation
          });
        }
      }
    });
  }
}

function getAddressSuggestions(query, container) {
  // Use Mapbox Geocoding API to get address suggestions
  const geocodingUrl = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
    query
  )}.json?access_token=${mapboxAccessToken}&limit=5`;

  fetch(geocodingUrl)
    .then((response) => response.json())
    .then((data) => {
      if (data.features && data.features.length > 0) {
        // Clear previous suggestions
        container.innerHTML = "";

        // Create suggestion items
        data.features.forEach((feature) => {
          const suggestionItem = document.createElement("div");
          suggestionItem.className = "store-locator__suggestion-item";
          suggestionItem.textContent = feature.place_name;

          // Add click event to suggestion item
          suggestionItem.addEventListener("click", () => {
            // Set input value to selected suggestion
            document.getElementById("address-input").value = feature.place_name;

            // Hide suggestions
            container.style.display = "none";

            // Update map and distances
            const [lng, lat] = feature.center;

            // Center map on the found location without animation
            map.setCenter([lng, lat]);
            map.setZoom(13);

            // Calculate distances to boutiques and update the list
            updateDistances(lat, lng);
          });

          container.appendChild(suggestionItem);
        });

        // Show suggestions container
        container.style.display = "block";
      } else {
        container.style.display = "none";
      }
    })
    .catch((error) => {
      console.error("Error getting address suggestions:", error);
      container.style.display = "none";
    });
}

function searchAddress(address) {
  // Use Mapbox Geocoding API to search for the address
  const geocodingUrl = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
    address
  )}.json?access_token=${mapboxAccessToken}&limit=1`;

  fetch(geocodingUrl)
    .then((response) => response.json())
    .then((data) => {
      if (data.features && data.features.length > 0) {
        const feature = data.features[0];
        const [lng, lat] = feature.center;

        // Center map on the found location without animation
        map.setCenter([lng, lat]);
        map.setZoom(13);

        // Calculate distances to boutiques and update the list
        updateDistances(lat, lng);
      }
    })
    .catch((error) => {
      console.error("Error searching address:", error);
    });
}

function updateDistances(lat, lng) {
  // Calculate distance from search point to each boutique
  boutiques.forEach((boutique) => {
    boutique.distance = calculateDistance(
      lat,
      lng,
      boutique.latitude,
      boutique.longitude
    );
  });

  // Sort boutiques by distance
  boutiques.sort((a, b) => a.distance - b.distance);

  // Re-render the list
  renderBoutiques(boutiques);
}

function calculateDistance(lat1, lon1, lat2, lon2) {
  // Haversine formula to calculate distance between two points
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in km

  // Convert to minutes (assuming average walking speed of 5 km/h)
  const minutes = Math.round((distance / 5) * 60);

  return minutes;
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}
